import styled from 'styled-components'

export const StyledHorizontalRule = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({theme}) => theme.colors.grey.grey100};
`
